import { Button, Spin } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { post } from '../../Common/api'
import EventForm from './EventForm'
import { Color } from '../../Common/Color'
import { WarningOutlined } from '@ant-design/icons'
import CustModal from '../../Common/CustModal'

export default function CreateEventCard ({ box, appointment, minimized = false }) {
  const [modalVisible, setModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form] = useForm()
  const navigate = useNavigate()

  const onClick = () => {
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    setLoading(true)
    await post({
      url: 'admin/events',
      params: values,
      onSuccess: (response) => {
        setModalVisible(false)
        navigate(`/admin/events/${response.event.id}`)
      }
    })
  }

  return (
    <>
      <CustModal
        open={modalVisible}
        setOpen={setModalVisible}
        title={t('Admin.Event.title.create')}
        confirmLoading={loading}
        onOk={form.submit}
      >
        <Spin spinning={loading}>
          <EventForm form={form} onFinish={onAdd} appointmentId={appointment?.id} boxId={box?.id} />
        </Spin>
      </CustModal>
      {minimized && <Button type="primary" size="large" icon={<WarningOutlined />} onClick={onClick} className='hoverable'
        style={{ '--hover-color': Color.red, boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)', border: '1px solid darkgrey' }} />
      }
      {!minimized &&
        <div style={{
          boxShadow: '0px 0px 2px 2px #f2f2f2',
          borderRadius: '1em',
          padding: '1em',
          margin: '1em',
          maxWidth: '290px',
          fontSize: '1.2em',
          textAlign: 'center'
        }}>
          <div style={{ fontWeight: 'bold' }}>
            {t('Admin.Event.create')}
            <br/>
            {box?.teleconsulting_company_name}
          </div>

          <Button style={{ marginTop: '0.5em' }} onClick={onClick} type="primary" icon={<WarningOutlined />}>
            {t('Admin.Event.createButton')}
          </Button>
        </div>
      }
    </>
  )
}
